module.exports = __webpack_public_path__ + "img/logo.604702a5.svg";